package com.presentocracy.web

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event

private const val GOOGLE_WEB_CLIENT_ID =
    "940723205849-924d679bgqhermmumeu246dhjhghc56j.apps.googleusercontent.com"
private const val GOOGLE_BUTTON_ID = "presentocracy-google-sign-in"
private const val GOOGLE_READY_EVENT = "presentocracy-google-library-ready"

@Composable
fun GoogleSignInButton(
    onCredential: (String) -> Unit,
    disabled: Boolean,
) {
    DisposableEffect(onCredential) {
        val browserWindow = window.asDynamic()
        browserWindow.presentocracyGoogleCredentialHandler = { credential: String ->
            onCredential(credential)
        }

        val renderGoogleButton = {
            val google = browserWindow.google
            val element = document.getElementById(GOOGLE_BUTTON_ID) as? HTMLElement
            if (google != null && google != undefined && element != null) {
                if (browserWindow.presentocracyGoogleInitialized != true) {
                    val config = js("({})")
                    config.client_id = GOOGLE_WEB_CLIENT_ID
                    config.callback = browserWindow.presentocracyHandleGoogleCredential
                    config.auto_select = false
                    google.accounts.id.initialize(config)
                    browserWindow.presentocracyGoogleInitialized = true
                }
                element.innerHTML = ""
                val options = js("({})")
                options.type = "standard"
                options.theme = "outline"
                options.size = "large"
                options.text = "continue_with"
                options.shape = "pill"
                options.logo_alignment = "left"
                options.width = minOf(element.clientWidth.coerceAtLeast(220), 400)
                google.accounts.id.renderButton(element, options)
            }
        }
        val readyListener: (Event) -> Unit = { renderGoogleButton() }
        window.addEventListener(GOOGLE_READY_EVENT, readyListener)
        renderGoogleButton()

        onDispose {
            window.removeEventListener(GOOGLE_READY_EVENT, readyListener)
            browserWindow.presentocracyGoogleCredentialHandler = null
        }
    }

    Div(attrs = {
        attr("id", GOOGLE_BUTTON_ID)
        classes("google-sign-in", if (disabled) "google-sign-in-disabled" else "google-sign-in-enabled")
        attr("aria-label", "Продолжить с Google")
    })
}

fun disableGoogleAutoSelect() {
    val google = window.asDynamic().google
    if (google != null && google != undefined) {
        google.accounts.id.disableAutoSelect()
    }
}
